module.exports = __webpack_public_path__ + "img/colazione_4.ea581b5e.jpeg";